import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import VocabulariesTableColumns from './VocabulariesTableColumns';

const VocabulariesTableHeader = ({
  children,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns="4"
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    <VocabulariesTableColumns />
  </Table.Header>
);

export default VocabulariesTableHeader;
